export default __webpack_public_path__ + "static/media/logo03.b9b253e7.png";